import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const CreatePatientApi = async data => {
    const callResponse = await axios({
        url: endpoints.CreatePatientWeconfig,
        method: "POST",
        headers: getHeaders(),

        data,
    })
        .then(response => response.data)
        .catch(err => err.response.data);

    return callResponse;
};